import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthService } from 'app/core/auth/auth.service';
import { ApiService } from 'app/shared/api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent implements OnInit {
    profileData: any = {
        name: '',
        email: '',
        username: ''
    };

    // Password change properties
    current_password: string = '';
    password: string = '';
    password_confirmation: string = '';

    isModalOpen = false;
    isSubmitting = false;

    constructor(private authService: AuthService, private apiService: ApiService) { }

    ngOnInit(): void {
        this.getProfile();
    }

    async getProfile(): Promise<void> {
        try {
            const response = await this.apiService.get('/api/v1/account/my-profile');
            this.profileData = response.data;
            // console.log(this.profileData);
        } catch (error) {
            console.error(error);
        }
    }

    async updateProfile(): Promise<void> {

        this.isSubmitting = true;

        try {
            // Hanya kirim field yang ada di form (name, email, username)
            const payload = {
                name: this.profileData.name,
                email: this.profileData.email,
                username: this.profileData.username
            };

            const response = await this.apiService.put('/api/v1/account/my-profile', payload);
            // console.log(response);

            // Cek apakah response sukses
            if (response.success === false) {
                // Handle validation errors
                let errorMessage = response.message || 'Gagal mengupdate profile';

                if (response.errors) {
                    const errorMessages = Object.values(response.errors)
                        .flat()
                        .join('\n');
                    errorMessage = errorMessages || errorMessage;
                }

                await Swal.fire({
                    icon: 'error',
                    title: 'Gagal',
                    text: errorMessage,
                    confirmButtonColor: '#dc3545',
                });
                return;
            }

            await Swal.fire({
                icon: 'success',
                title: 'Berhasil',
                text: 'Profile berhasil diupdate',
                confirmButtonColor: '#28a745',
                timer: 2000,
                showConfirmButton: false,
            });
            
            // Update user data in AuthService and notify all subscribers
            const currentUser = this.authService.getCurrentUser();
            if (currentUser) {
                const updatedUser = {
                    ...currentUser,
                    name: this.profileData.name,
                    email: this.profileData.email,
                    username: this.profileData.username
                };
                this.authService.updateUserData(updatedUser);
            }

        } catch (error: any) {
            console.error('Error updating profile:', error);

            let errorMessage = 'Gagal mengupdate profile';

            // Handle error response
            if (error?.error?.errors) {
                const errorMessages = Object.values(error.error.errors)
                    .flat()
                    .join('\n');
                errorMessage = errorMessages;
            } else if (error?.error?.message) {
                errorMessage = error.error.message;
            } else if (error?.message) {
                errorMessage = error.message;
            }

            await Swal.fire({
                icon: 'error',
                title: 'Gagal',
                text: errorMessage,
                confirmButtonColor: '#dc3545',
            });
        } finally {
            this.isSubmitting = false;
        }
    }

    openChangePasswordModal() {
        this.isModalOpen = true;
        // Reset password fields
        this.current_password = '';
        this.password = '';
        this.password_confirmation = '';
    }

    closeChangePasswordModal() {
        this.isModalOpen = false;
    }

    async updatePassword(): Promise<void> {
        // Validasi password match
        if (this.password !== this.password_confirmation) {
            await Swal.fire({
                icon: 'error',
                title: 'Gagal',
                text: 'Password dan konfirmasi password tidak cocok',
                confirmButtonColor: '#dc3545',
            });
            return;
        }

        this.isSubmitting = true;
        try {
            // Kirim hanya field password yang diperlukan
            const payload = {
                current_password: this.current_password,
                password: this.password,
                password_confirmation: this.password_confirmation
            };

            const response = await this.apiService.put('/api/v1/account/change-password', payload);
            // console.log(response);

            // Cek apakah response sukses
            if (response.success === false) {
                // Handle validation errors
                let errorMessage = response.message || 'Gagal mengupdate password';

                if (response.errors) {
                    const errorMessages = Object.values(response.errors)
                        .flat()
                        .join('\n');
                    errorMessage = errorMessages || errorMessage;
                }

                await Swal.fire({
                    icon: 'error',
                    title: 'Gagal',
                    text: errorMessage,
                    confirmButtonColor: '#dc3545',
                });
                return;
            }

            await Swal.fire({
                icon: 'success',
                title: 'Berhasil',
                text: 'Password berhasil diupdate',
                confirmButtonColor: '#28a745',
                timer: 2000,
                showConfirmButton: false,
            });

            // Tutup modal setelah sukses
            this.closeChangePasswordModal();

        } catch (error: any) {
            console.error('Error updating password:', error);

            let errorMessage = 'Gagal mengupdate password';

            // Handle error response
            if (error?.error?.errors) {
                const errorMessages = Object.values(error.error.errors)
                    .flat()
                    .join('\n');
                errorMessage = errorMessages;
            } else if (error?.error?.message) {
                errorMessage = error.error.message;
            } else if (error?.message) {
                errorMessage = error.message;
            }

            await Swal.fire({
                icon: 'error',
                title: 'Gagal',
                text: errorMessage,
                confirmButtonColor: '#dc3545',
            });
        } finally {
            this.isSubmitting = false;
        }
    }
}
